import React from 'react';
import { MapPin, Package, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { SectionHeader } from './shared/SectionHeader';

const regionIcons = [
  { icon: '🕌', color: 'from-brand-green to-[#164d3d]' },
  { icon: '🏛', color: 'from-brand-green to-[#1a5c47]' },
  { icon: '🗽', color: 'from-brand-green to-[#0d3326]' },
];

export default function GlobalFootprint() {
  const { t } = useLanguage();
  const regions = t('markets.regions');

  return (
    <section id="markets" className="py-24 md:py-32 bg-slate-50" data-testid="markets-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader label={t('markets.sectionLabel')} title={t('markets.title')} />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {Array.isArray(regions) && regions.map((region, i) => (
            <div
              key={region.name}
              className={`bg-gradient-to-br ${regionIcons[i]?.color} p-8 md:p-10 relative overflow-hidden group`}
              data-testid={`market-card-${i}`}
            >
              <div className="absolute top-4 right-4 text-4xl opacity-20">
                {regionIcons[i]?.icon}
              </div>

              <div className="relative z-10">
                <h3 className="font-heading text-2xl font-bold text-white mb-6">
                  {region.name}
                </h3>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <MapPin className="w-4 h-4 text-brand-orange flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-white/50 text-xs uppercase tracking-wider font-semibold">Countries</p>
                      <p className="text-white/90 text-sm mt-0.5">{region.countries}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Package className="w-4 h-4 text-brand-orange flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-white/50 text-xs uppercase tracking-wider font-semibold">Products</p>
                      <p className="text-white/90 text-sm mt-0.5">{region.products}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <ShieldCheck className="w-4 h-4 text-brand-orange flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-white/50 text-xs uppercase tracking-wider font-semibold">Key Advantage</p>
                      <p className="text-white/90 text-sm mt-0.5 font-medium">{region.highlight}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 h-1 bg-brand-orange transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
